// extracted by mini-css-extract-plugin
export var container = "_cp-1";
export var cornerButtonContainer = "_cp-6";
export var disabled = "_cp-2";
export var dragActive = "_cp-3";
export var fileContainer = "_cp-5";
export var hiddenInput = "_cp-4";
export var widthContainer = "_cp-0";